import React, { useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router';
import { signInAnonymously } from '@firebase/auth';
import { set, ref } from '@firebase/database';
import { auth, database } from '../api/firebase';
import { MAX_NICKNAME_LENGTH } from '../constants/form';
import { createNewBubbleRoom, generateRoomCode } from '../helpers/room';
import IBubbleRoom from '../types/room';
import ErrorText, { INTERNAL_SERVER_ERROR_TEXT } from './ErrorText';

interface FormCreateBubbleProps { }

const FormCreateBubble: React.FC<FormCreateBubbleProps> = () => {
  const history = useHistory();
  const [nickname, setNickname] = useState<string>('');
  const [isFetching, setIsFetching] = useState<boolean>(false);
  const [error, setError] = useState<string>('');
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    inputRef.current!.focus();
  }, [])

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    try {
      setIsFetching(true);
      setError('');
      const creds = await signInAnonymously(auth);
      createAndJoinBubble(creds.user.uid);
    } catch (error) {
      console.log(error);
      setError(INTERNAL_SERVER_ERROR_TEXT);
    } finally {
      setIsFetching(false);
    }
  };

  const createAndJoinBubble = (userId: string) => {
    const bubble: IBubbleRoom = createNewBubbleRoom();
    const roomcode: string = generateRoomCode();
    bubble.users[userId] = { nickname };
    set(ref(database, `bubbles/${roomcode}`), bubble); // uncaught exception around here
    history.push(`/${roomcode}`);
  };

  return (
    <div>
      <p className="text-white m-0 text-2xl select-none">nickname</p>
      <form className="flex justify-center items-center" onSubmit={handleSubmit}>
        <input
          className={
            "text-white border-none w-full p-2 m-0 h-8 outline-none bg-black bg-opacity-20 rounded-r-none rounded-l-xl " +
            `${isFetching ? 'cursor-not-allowed' : 'cursor-auto'}`
          }
          type="text"
          value={nickname}
          ref={inputRef}
          onChange={(e: React.FormEvent<HTMLInputElement>) => setNickname(e.currentTarget.value.trimLeft())}
          maxLength={MAX_NICKNAME_LENGTH}
          disabled={isFetching}
        />
        <button
          className={
            "border-none m-0 pr-1 h-8 w-16 text-white bg-blue-400 rounded-l-none rounded-r-xl outline-none " +
            "disabled:bg-gray-500 disabled:cursor-not-allowed"
          }
          disabled={nickname === '' || isFetching}
        >
          start
        </button>
      </form>
      {error && <ErrorText message={error} />}
    </div>
  );
};

export default FormCreateBubble;
